import React, {useEffect, useMemo, useState} from "react";
import {SLA_REPORT_LIST_HEADER} from "../../../../../components/table/header/Headers";
import {removeSlaReports} from "../../../../../api/evaluation/SlaService";
import {handleActiveError, handleActiveToast} from "../../../../../components/sonner/ToastBasic";
import Search from "../../../../../components/search/Search";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, simmsColumnsToJsGridHeaders} from "../../../../../components/commonmethod/CommonMethod";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../../components/pageTabs/pageTabsStorage";
import {useNavigate} from "react-router-dom";
import {useExcelDownloadClick} from "../../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../../components/js-grid/JsGridExcelGridOpenButton";

function SlaReportListType({checked, data, date, dataHook, pageInfo}) {
    const navigate = useNavigate();
    const {handleSearch, handlePageSizeChange, searchConditions, saveConditions, refresh, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const [header, setHeader] = useState({order: SLA_REPORT_LIST_HEADER, exclude: []});
    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate};

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, SLA_REPORT_LIST_HEADER, setHeader, [], () => {}, () => {}, 'sla_report');
        });
    }, []);

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "SLA 보고서"),
            url: `/evaluation/slaCompare/report/${id}`,
        });
    };

    const deleteSlaReport = async (rows) => {
        if (!rows?.length) {
            handleActiveToast({message: "삭제할 보고서를 선택해주세요."});
            return;
        }
        if (!window.confirm("삭제하시겠습니까?")) {
            return;
        }
        const ids = rows.map((row) => row.id).filter((id) => id != null);
        await removeSlaReports({ids}).then((response) => {
            if (response.status === 200) {
                handleActiveToast({message: "데이터가 삭제되었습니다"});
            } else if (response.status === 403) {
                handleActiveError({message: "권한이 없습니다."});
            } else {
                handleActiveError({message: "알 수 없는 에러 발생."});
            }
        });
        checked?.setChecked?.([]);
        refresh();
    };

    const slaReportJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(searchConditions ?? saveConditions), [searchConditions, saveConditions]);

    return (
        <div className="container-height">
            <Search refresh={refresh} entity={'sla_report'} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo} size date={searchDate} />
            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={slaReportJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {sla_report: v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'sla_report')}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="ExcelSlaReportDto" search={excelGridSearch} />
                            <ToolbarDataTransfer
                                hint="선택 항목 삭제"
                                busyHint="삭제 중…"
                                overlayLabel="삭제 중…"
                                onTransfer={deleteSlaReport}
                            >
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                        onClick={() => {
                                            if (ctx.selectedCount === 0) {
                                                handleActiveToast({message: "삭제할 보고서를 선택해주세요."});
                                                return;
                                            }
                                            void ctx.transferSelected();
                                        }}
                                    >
                                        삭제
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                        </div>
                    )}
                />
            </div>
        </div>
    );
}

export {SlaReportListType};
